import InputTextComp from "@components/UI/InputText/Index.jsx";
import { SaveTipo } from "@services/Tipo/Index.jsx";
import { useForm } from "react-hook-form";
import ButtonComp from "@components/UI/Button/Index.jsx";
import SweetAlert from "@components/Feedback/SweetAlert/Index.jsx";
import SelectOptionComp from "@components/UI/SelectOption/Index.jsx";
import { useEffect } from "react";
import { blockedOptionMessage } from '@utils/Index.jsx';
import { useFetchDataCascade } from "@hooks/api/useFetchDataCascade.js";

const Create = ({ onSave }) => {

    const {
        register,
        handleSubmit,
        reset,
        setValue,
        watch,
    } = useForm({
        defaultValues: {
            ano: null,
            servico: null,
            tipo: "",
            descricao: "",
        },
    });

    const {
        yearOptions,
        serviceOptions,
        yearLoading,
        serviceLoading,
        fetchYears,
        fetchServicesByYear,
        fetchTypesByServiceId,
        setServiceOptions,
    } = useFetchDataCascade();

    const onSubmit = async (data) => {
        try {
            SweetAlert.loading();

            const payload = {
                idTipoServico: data.servico?.value,
                tipo: data.tipo,
                descricao: data.descricao,
                flgStatus: true,
            };

            const result = await SaveTipo(payload);

            SweetAlert.success("Cadastro Realizado!", "Os dados foram salvos com sucesso.");

            onSave({ ...result });

            reset({
                ano: null,
                servico: null,
                tipo: "",
                descricao: "",
            });

        } catch (error) {
            const errorMessage = error.parsed?.message || 'Não foi possível salvar o tipo.';

            SweetAlert.errorHTML('Erro ao cadastrar', errorMessage);
            console.error(error);
        }
    };

    const ano = watch("ano");
    const servico = watch("servico");
    const tipo = watch("tipo");

    useEffect(() => {
        fetchYears();
    }, []);

    useEffect(() => {
        const selectedYear = ano?.value;

        if (selectedYear) {
            setValue("servico", null);
            setValue("tipo", null);
            setValue("descricao", "");
            fetchServicesByYear(selectedYear);
        } else {
            setServiceOptions([]);
            setValue("servico", null);
            setValue("tipo", null);
            setValue("descricao", "");
        }
    }, [ano]);

    useEffect(() => {
        const selectedServiceId = servico?.value;

        if (selectedServiceId) {
            setValue("tipo", "");
            setValue("descricao", "");
            fetchTypesByServiceId(selectedServiceId);
        } else {
            setValue("tipo", null);
            setValue("descricao", "");
        }
    }, [servico]);

    useEffect(() => {
        if (!tipo) {
            setValue("descricao", "");
        }
    }, [tipo]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="form">
            <div className="row">

                <div className="p-3">
                    <h3> - Observação: Os campos serão habilitados conforme o preenchimento do atual campo habilitado. </h3>
                </div>

                <div className="col-5 col-md-5">
                    <SelectOptionComp
                        label="Ano"
                        options={yearOptions}
                        value={watch("ano")}
                        onChange={(selected) => setValue("ano", selected)}
                        placeholder="Selecionar um ano"
                        hoverMessage="Selecionar um ano"
                        isLoading={yearLoading}
                        required
                    />
                </div>

                <div className="col-8 col-md-8">

                    <SelectOptionComp
                        label="Serviço"
                        options={serviceOptions}
                        value={watch("servico")}
                        onChange={(selected) => setValue("servico", selected)}
                        placeholder={watch("ano") ? "Selecionar um serviço" : blockedOptionMessage}
                        hoverMessage="Selecionar um serviço"
                        isDisabled={!watch("ano")}
                        isLoading={serviceLoading}
                        required
                    />

                    <InputTextComp
                        label="Tipo"
                        name="tipo"
                        {...register("tipo")}
                        placeholder={watch("servico") ? "Preencher com um tipo" : blockedOptionMessage}
                        hoverMessage="Preencher com um tipo"
                        maxLength={255}
                        disabled={!watch("servico")}
                        required={true}
                    />

                    <InputTextComp
                        label="Descrição"
                        name="descricao"
                        {...register("descricao")}
                        placeholder={watch("tipo") ? "Preencher com uma descrição" : blockedOptionMessage}
                        hoverMessage="Preencher com uma descrição"
                        maxLength={255}
                        disabled={!watch("tipo")}
                        required={true}
                    />
                </div>

                <div className="col-md-8 mt-4">

                    <ButtonComp
                        title="SALVAR"
                        type="submit"
                        buttonColor="#2b97be"
                        classnameIcon="fa-regular fa-floppy-disk"
                        hoverMessage={"Botão para confirmar o cadastro"}
                    />

                </div>

            </div>
        </form>
    );
};

export default Create;
